import {Dispatch} from 'react'
import {State} from '../../reducers'
import {generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalShowLoader} from '../general.actions'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import { ItemLibroCF, ItemLibroContribuyente, ItemLibroGenerado, LibrosAction } from '../../interfaces/libros.interface'
import { LIBROS_TYPES } from '../../constants/libros.types'
import { REGEX_REPLACE_SLASH } from '../../constants/Regex'

const VENTAS_FILE = process.env.REACT_APP_VENTAS_FILE;

export const setFormVentas = (form: any) => ({ type: LIBROS_TYPES.LIBRO_CHANGE_FORM_VENTAS, payload: form })
export const setFormConsultaVentas = (form: any) => ({ type: LIBROS_TYPES.LIBRO_CHANGE_FORM_CONSULTA_VENTAS, payload: form })
export const setFormConsultaLibros = (form: any) => ({ type: LIBROS_TYPES.LIBRO_CHANGE_FORM_CONSULTA_LIBROS, payload: form })
export const setDataConsultaVentas = (data: Array<ItemLibroCF | ItemLibroContribuyente>) => ({ type: LIBROS_TYPES.LIBRO_SET_DATA_CONSULTA_VENTAS, payload: data })
export const setTableVentasTotalPaginas = (paginas: number) => ({ type: LIBROS_TYPES.LIBRO_VENTAS_SET_TABLE_PAGINAS, payload: paginas })
export const setTableVentasPaginaActual = (pagina: number) => ({ type: LIBROS_TYPES.LIBRO_VENTAS_SET_TABLE_PAGINA_ACTUAL, payload: pagina })
export const setDataHistorialConsultaLibros = (data: Array<ItemLibroGenerado>) => ({ type: LIBROS_TYPES.LIBRO_HISTORIAL_VENTAS_SET_CONSULTA_LIBROS, payload: data })
export const clearLibroVentasModule = () => ({ type: LIBROS_TYPES.LIBROS_CLEAR_MODULE, payload: {} })

export const ventasOpenModalFormatos = (open: boolean) => ({ type: LIBROS_TYPES.VENTAS_MODAL_FORMATOS_DESCARGAS, payload: open })
export const ventasOpenModelCargarFormato = (open: boolean) => ({ type: LIBROS_TYPES.VENTAS_MODAL_CARGAR_FORMATOS, payload: open })

// ******************************************************************************************
// ? PETICIONES REST
// ******************************************************************************************
export const getDataConsultaDocsVenta = (form: any, pagina: number = 1) => async (dispatch: Dispatch<LibrosAction>, getState: () => State) => {
  dispatch(generalShowLoader(true));
  const {dataConsultaVentas} = getState().libros
  const formConsulta = {
    fechaInicio: form.startDate,
    fechaFin: form.endDate,
    tipolibro: form.tipoLibro,
    pagina: pagina,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  await http
    .post(ENDPOINTS.CONSULTA_GENERAL_DOCS_VENTAS, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res?.body?.length > 0) {
        const paginasConsulta = res?.body[0]?.paginas;
        const dataProc = res.body.map((item: any) => {
          return { ...item, pagina: pagina };
        });
        
        dispatch(setFormConsultaVentas(form));
        dispatch(setDataConsultaVentas(pagina === 1 ? dataProc : [...dataConsultaVentas, ...dataProc]));
        dispatch(setTableVentasTotalPaginas(paginasConsulta));
        dispatch(setTableVentasPaginaActual(pagina));
        return;
      }
      dispatch(setDataConsultaVentas([]));
      dispatch(generalOpenModalInfo(res.message || "No hay documentos disponibles y/o emitidos en el período seleccionado."))
    })
    .catch((err) => {
      const messageErr = 'No se logró obtener los datos de los documentos en el período seleccionado';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const getDataLibrosGenerados = (form: any) => async (dispatch: Dispatch<LibrosAction>) => {
  dispatch(generalShowLoader(true));
  const formConsulta = {
    fechaInicio: form.startDate,
    fechaFin: form.endDate,
    tipoLibro: form.tipoLibro,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  await http
    .post(ENDPOINTS.LIBRO_VENTAS_GET_GENERADOS, formConsulta, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res?.body?.length > 0) {

        dispatch(setDataHistorialConsultaLibros(res?.body));
        return;
      }
      dispatch(setDataHistorialConsultaLibros([]));
      dispatch(generalOpenModalInfo(res.message || "No hay libros generados en el período seleccionado"))
    })
    .catch((err) => {
      const messageErr = 'No se logró obtener los datos de los libros en el período seleccionado';
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const setCargarRetencionesVentas = (base64File: string, serieFile: string, extFile: string = "xlsx", formFechas: any = {}) => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true));
  const messageErr = 'No se logró cargar los datos de retenciones, por favor intentar nuevamente.';

  const formCarga = {
    base64Excel: base64File,
    serie: serieFile,
    extension: extFile,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
    fechaInicio: formFechas.startDate,
    fechaFinal: formFechas.endDate,
  }
  
  return await http
    .post(ENDPOINTS.LIBRO_VENTAS_CARGAR_RETENCIONES, formCarga, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Documentos cargados", "Los registros de retenciones ya fueron cargados exitosamente."));
      return true;
    })
    .catch((err) => {
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const postGenerarLibroVentas = (idLibro: number = 0, formAux: any = {}) => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true));
  const messageErr = 'No se logró generar el libro de ventas, por favor intentar nuevamente.';
  const {formConsultaVentas} = getState().libros

  const startDate = formAux?.startDate ?? formConsultaVentas.startDate;
  const endDate = formAux?.endDate ?? formConsultaVentas.endDate;
  const form = {
    idLibro,
    fechaInicio: startDate,
    fechaFin: endDate,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  const tipoLibro = formAux?.tipoLibro ?? formConsultaVentas.tipoLibro;
  const urlEndpoint = tipoLibro === "01" ? ENDPOINTS.LIBRO_VENTAS_GENERAR_CF : ENDPOINTS.LIBRO_VENTAS_GENERAR_CONTRIBUYENTES;
  const auxNameFile = tipoLibro === "01" ? "CF" : "CONTRIBUYENTES";
  
  return await http
    .post(urlEndpoint, form, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res?.body) {
        const itemExcel = res?.body[0];
        const decodedData = atob(itemExcel?.Excel);
        const byteArray = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; i++) {
          byteArray[i] = decodedData.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${VENTAS_FILE}_${auxNameFile}_PERIODO_(${startDate.replace(REGEX_REPLACE_SLASH, '-')}_${endDate.replace(REGEX_REPLACE_SLASH, '-')}).xlsx`;

        // Simular un clic en el enlace de descarga
        document.body.appendChild(a);
        a.click();
        // Limpiar el enlace y el objeto URL
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        if (idLibro === 0) {
          dispatch(generalOpenModalMessage("Libro creado exitosamente", `Todos los documentos correspondientes al período seleccionado, desde ${startDate} hasta ${endDate}, han sido registrados en el libro.`));
        } 

        dispatch(setFormConsultaVentas({}));
        dispatch(setDataConsultaVentas([]));
        dispatch(setTableVentasPaginaActual(0));
        dispatch(setTableVentasTotalPaginas(0));
      }
      return true;
    })
    .catch((err) => {
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const postAnularLibroVentas = (libroVentas: ItemLibroGenerado) => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true));
  const messageErr = 'No se logró anular el libro de ventas, por favor intentar nuevamente.';
  const {formConsultaLibros} = getState().libros;
  const form = {
    idLibro: libroVentas.idlibroventa,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_VENTAS_ANULAR, form, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(getDataLibrosGenerados(formConsultaLibros));
      dispatch(generalOpenModalMessage("Libro anulado", "Libro anulado correctamente, los documentos asociados al libro fueron liberados."));
      return true;
    })
    .catch((err) => {
      dispatch(generalShowLoader(false));
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
}

export const setCargarAnexos = (base64File: string, typeFile: string = "xlsx", numeroAnexo: number) => async (dispatch: Dispatch<any>, getState: () => State) => {
  dispatch(generalShowLoader(true));
  const messageErr = 'No se logró cargar los datos, por favor intentar nuevamente.';

  const formCarga = {
    base64File,
    numeroAnexo,
    typeFile,
    tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
  }

  return await http
    .post(ENDPOINTS.LIBRO_CARGAR_ANEXOS, formCarga, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      dispatch(generalOpenModalMessage("Documento cargado", "Los registros ya fueron cargados exitosamente."));
      return true;
    })
    .catch((err) => {
      dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
      return false;
    })
    .finally(() => dispatch(generalShowLoader(false)))
}
